import {
	UPDATE_KEYWORDS,
	FETCHING_KEYWORDS,
	FETCHED_KEYWORDS,
	FLUSH_QUERY
} from "../../actions/QueryBuilder/actionConstants";

const keywords = (state = { list: [], isFetching: false }, action) => {
	switch (action.type) {
		/**
		 * action: {
		 *  type,
		 *  keywords
		 * }
		 */
		case UPDATE_KEYWORDS:
			return Object.assign({}, state, { list: action.keywords });
		/**
		 * action: {
		 *  type
		 * }
		 */
		case FETCHING_KEYWORDS:
			return Object.assign({}, state, { isFetching: true });
		/**
		 * action: {
		 *  type
		 * }
		 */
		case FETCHED_KEYWORDS:
			return Object.assign({}, state, { isFetching: false });
		/**
		 * action: {
		 * 	type
		 * }
		 */
		case FLUSH_QUERY:
			return {
				list: [],
				isFetching: false
			};
		default:
			return state;
	}
};

export default keywords;
